import { IPayload } from "Model/IPayload";
import { API_URL, apiMethod, apiType } from "utils";
import FleetManagementApiService from "./FleetManagementApiService";
import { all, call, put, select, takeEvery } from "redux-saga/effects";
import {
  setFleetVendorEmailHistory,
  setFleetVendorEmailHistoryMessage,
} from "../../Store/FleetManagement/FleetPOVendorEmailHistory/FleetPOVendorEmailHistoryAction";
import { globalLoaderText } from "redux/CommonDashboard/actions";
import {
  GET_VENDOR_EMAIL_HISTORY,
  GET_VENDOR_EMAIL_HISTORY_MESSAGE,
} from "Store/FleetManagement/FleetPOVendorEmailHistory/FleetPOVendorEmailHistoryType";

const getData = (payload? : any, response?:any,fleetPOVendorEmailHistoryTemp? : any) =>{
  let result = {}
  result = {
    id: payload.fleetDetailId,
    response: response,
    isOpen : true,
    pageNumber : payload.pageNumber,
    pageSize : payload.pageSize
  };
  fleetPOVendorEmailHistoryTemp?.push(result);
  return fleetPOVendorEmailHistoryTemp;
}

function* getfleetPOVendorEmailHistory(req: any): any {
  const fleetPOVendorEmailHistory = yield select(
    (state: any) =>
      state?.POVendorEmailHistoryReducers?.fleetVendorEmailHistory
  );
  let fleetPOVendorEmailHistoryTemp = [];
    if (fleetPOVendorEmailHistory?.length) {
      fleetPOVendorEmailHistoryTemp = fleetPOVendorEmailHistory?.filter(
        (filterItem?: any) => filterItem?.id != req?.payload?.fleetDetailId
      );
    }
  try {
    yield put(globalLoaderText("Fetching PO Vendor Email History...."));
    let payloadData: IPayload = {
      apiType: apiType.FleetManagement,
      endpoint: "fleet/povendoremail/history",
      apiMethod: apiMethod.POST,
      payload: req.payload,
    };
    const response = yield call(
      FleetManagementApiService.post,
      API_URL.PostWebApp,
      payloadData
    );
   
    if (response?.data.length) {
      let dataTemp = getData(req.payload,response,fleetPOVendorEmailHistoryTemp)
      yield put(setFleetVendorEmailHistory(dataTemp));
      yield put(globalLoaderText(""));
    } else {
      let dataTemp = getData(req.payload,{},fleetPOVendorEmailHistoryTemp)
      yield put(setFleetVendorEmailHistory(dataTemp));
      yield put(globalLoaderText(""));
    }
  } catch (error: any) {
    let dataTemp = getData(req.payload,{},fleetPOVendorEmailHistoryTemp)
    yield put(setFleetVendorEmailHistory(dataTemp));
    yield put(setFleetVendorEmailHistory(fleetPOVendorEmailHistoryTemp));
    yield put(globalLoaderText(""));
  }
}

function* getFleetPoVendorEmailHistoryMessage(req: any): any {
  try {
    yield put(globalLoaderText("Fetching Email Message...."));
    let payloadData: IPayload = {
      apiType: apiType.FleetManagement,
      endpoint: `fleet/povendoremail/history/${req.emailHistory.emailHistoryId}`,
      apiMethod: apiMethod.GET,
      payload: null,
    };

    const response = yield call(
      FleetManagementApiService.post,
      API_URL.PostWebApp,
      payloadData
    );
    if (response) {
      yield put(
        setFleetVendorEmailHistoryMessage({
          ...response,
          fleetDetailId: req.emailHistory.fleetDetailId,
        })
      );
      yield put(globalLoaderText(""));
    } else {
      yield put(setFleetVendorEmailHistoryMessage({}));
      yield put(globalLoaderText(""));
    }
  } catch (error) {
    yield put(setFleetVendorEmailHistoryMessage({}));
    yield put(globalLoaderText(""));
  }
}

function* fleetPOVendorEmailHistorySagaWatcher() {
  yield takeEvery(GET_VENDOR_EMAIL_HISTORY, getfleetPOVendorEmailHistory);
  yield takeEvery(
    GET_VENDOR_EMAIL_HISTORY_MESSAGE,
    getFleetPoVendorEmailHistoryMessage
  );
}

export default function* combinedSaga() {
  yield all([fleetPOVendorEmailHistorySagaWatcher()]);
}
